const setCopyPlace = {
  true: 'Rama',
  false: 'Hoja',
  text: 'seleccionado(a)',
  text1: 'agregado(a) al portapapeles'
};

export default setCopyPlace;
